import React, { Component } from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'
import Tooltip, { POSITION, ALIGN } from 'gnos-tooltip'
import _ from 'lodash'

import ContextBurger from '../../../../../../../../../../components/ContextBurger'
import Signals from '../../../../../../../../../../components/TableCell/components/Signals'
import Minireport from '../../../../../../../../../../components/Minireport'

import { SIGNALS_WITH_HIDDEN_ENTITY } from '../../constants'

import EntityFlags from './components/EntityFlags'

import './style.scss'

export default class SignalEntity extends Component {
    static propTypes = {
        block: PropTypes.string.isRequired,
        customData: PropTypes.object,
        entity: PropTypes.object,
        mainId: PropTypes.string.isRequired,
        module: PropTypes.string.isRequired,
        type: PropTypes.string,
    }

    shouldShowSubject(type) {
        return !SIGNALS_WITH_HIDDEN_ENTITY.includes(type)
    }

    render() {
        const {
            module,
            block,
            customData,
            mainId,
            type,
            entity: { subject, flags },
        } = this.props

        const minireport = <Minireport id={mainId} />

        return (
            <>
                {this.shouldShowSubject(type) && (
                    <div className={'signal-entity'}>
                        <div className={'signal-entity-icon'}>
                            <div className={cx('icon', _.get(subject, 'type', ''))} />
                        </div>
                        <div className={'signal-entity-content'}>
                            <Tooltip
                                id={`entity-minireport-tooltip-${mainId}_${Math.random()}`}
                                content={minireport}
                                position={POSITION.TOP}
                                align={ALIGN.LEFT}
                                width={'320px'}
                                showDelay={1000}
                                doubleWrap
                            >
                                <div className={'entity-name-container'}>
                                    <strong>{_.get(subject, 'name', '')}</strong>
                                    <div className={'burger-container'}>
                                        <ContextBurger entity={subject} id={_.get(subject, 'id', null)} />
                                    </div>
                                </div>
                            </Tooltip>
                            <div className={'secondary-entity-row'}>
                                {subject?.countryIso && subject?.countryIso !== 'CZ' && (
                                    <span
                                        className={cx(
                                            'flag-icon',
                                            `flag-icon-${_.get(subject, 'countryIso', '').toLowerCase()}`
                                        )}
                                    />
                                )}
                                <Signals
                                    id={_.get(subject, 'id', null)}
                                    risk={_.get(subject, 'indicators.risk', 0)}
                                    caution={_.get(subject, 'indicators.caution', 0)}
                                    notice={_.get(subject, 'indicators.notice', 0)}
                                    showZeroValues={false}
                                />
                            </div>
                        </div>
                    </div>
                )}
                <EntityFlags
                    mainId={mainId}
                    module={module}
                    block={block}
                    customData={customData}
                    flags={flags}
                    type={type}
                />
            </>
        )
    }
}
